if (!customElements.get('full-image-tabs')) {
    class FullImageTabs extends HTMLElement {
        constructor() {
            super();
            this.tabs = [];
            this.blocks = [];
            this.currentIndex = 0
        }
        connectedCallback() {
            this.tabs = this.querySelectorAll('.full-image-tabs__tab');
            this.blocks = this.querySelectorAll('.full-image-tabs__block');
            const _this = this;
            this.tabs.forEach(tab => tab.addEventListener('click', function(e) {
                _this.handleTabClick(e);
            }));

            if (this.dataset.autoSwitch === 'true') {
                this.initObserver();
            }
        }

        initObserver() {
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // 当元素进入视口80%且从未切换过
                    if (entry.isIntersecting && !this.hasSwitched) {
                        this.hasSwitched = true; // 标记为已切换
                        this.autoSwitch();
                        this.observer.disconnect(); // 切换后立即停止观察，避免重复触发
                    }
                });
            }, { threshold: 0.8 });

            this.observer.observe(this);
        }

        autoSwitch() {
            // 切换到下一个tab，如果当前是最后一个，则切换到第一个
            const nextIndex = (this.currentIndex + 1) % this.tabs.length;
            this.setActiveTab(nextIndex);
        }

         setActiveTab(index) {
            this.tabs.forEach(tab => tab.classList.remove('active'));
            this.blocks.forEach(block => block.classList.remove('active'));

            if (this.tabs[index] && this.blocks[index]) {
                this.tabs[index].classList.add('active');
                this.blocks[index].classList.add('active');
                this.currentIndex = index;
            }
        }

        handleTabClick(e) {
            const idx = e.currentTarget.getAttribute('data-tab-index');
            // if it is active, do nothing
            if (this.tabs[idx].classList.contains('active')) return;
            this.setActiveTab(idx);
        }
    }
    customElements.define('full-image-tabs', FullImageTabs);
}
